// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__8qMfz","amount":"Amount_amount__eQ6VE","tip":"Amount_tip__2vMxx","tipHeader":"Amount_tipHeader__3JKDm","tipsWrap":"Amount_tipsWrap__21g4I"};